'use strict';

/**
 * Remembers the product a user has opened from a product listing (category, search or filtered results)
 * to bring the user back to the same row of products on "back" navigation or PDP breadcrumb click.
 */

var STORAGE_KEY = 'plpPositions',
	TTL = 60 * 60 * 1000,
	MAX_ENTRIES = 10,
	// params which define only a rendered part of a listing, not a listing itself
	PAGING_PARAMS = ['start', 'sz', 'page', 'format', 'restore', 'plpdebug'];

/**
 * @description Logs to console if enabled by "plpdebug=1" URL param for the browser tab session
 */
function log() {
	try {
		if (/[?&]plpdebug=1(&|$)/.test(location.search)) {
			sessionStorage.setItem('plpPositionDebug', '1');
		}
		if (sessionStorage.getItem('plpPositionDebug') === '1' && window.console) {
			console.log.apply(console, ['[plp-position]'].concat([].slice.call(arguments)));
		}
	} catch (e) {
		// no logging
	}
}

function readAll() {
	var entries = [];
	try {
		entries = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];
	} catch (e) {
		entries = [];
	}
	return entries.filter(function (entry) {
		return entry && Date.now() - entry.time < TTL;
	});
}

function writeAll(entries) {
	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(0, MAX_ENTRIES)));
	} catch (e) {
		// storage is full or disabled: position won't be restored
	}
}

/**
 * @description Normalizes a listing URL: path + sorted listing params (refinements, sorting, search phrase)
 * @param {String} url
 * @returns {String}
 */
function getListingKey(url) {
	var link = document.createElement('a'),
		params;

	link.href = url;
	params = link.search.replace(/^\?/, '').split('&').filter(function (pair) {
		var name = pair.split('=')[0];
		try {
			name = decodeURIComponent(name);
		} catch (e) {
			// malformed param name, compare as is
		}
		return pair && PAGING_PARAMS.indexOf(name) === -1;
	}).sort();

	return link.pathname.replace(/\/$/, '') + '?' + params.join('&');
}

/**
 * @returns {String} 'navigate', 'reload', 'back_forward' or 'prerender'
 */
function getNavigationType() {
	var entries = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation') : [];

	if (entries.length) {
		return entries[0].type;
	}
	// deprecated API fallback for old browsers
	return window.performance && performance.navigation && performance.navigation.type === 2 ? 'back_forward' : 'navigate';
}

/**
 * @description Saves the opened product for a listing
 * @param {Object} data {url, cgid, pid, index, offset}
 */
function save(data) {
	var key = getListingKey(data.url),
		entries = readAll().filter(function (entry) {
			return entry.key !== key;
		});

	entries.unshift($.extend({}, data, {
		key: key,
		time: Date.now(),
		armed: false
	}));
	writeAll(entries);
	log('saved', entries[0]);
}

/**
 * @description Returns saved position for the current page if it has to be restored:
 * on "back" navigation or when the user came by a PDP breadcrumb link
 * @returns {Object|null}
 */
function getForRestore() {
	var key = getListingKey(location.href),
		entries = readAll(),
		entry = null,
		navigationType = getNavigationType();

	entries.forEach(function (item) {
		if (!entry && item.key === key) {
			entry = item;
		}
	});

	log('navigation:', navigationType, 'key:', key, 'saved:', entry);

	if (!entry || !(entry.armed || navigationType === 'back_forward')) {
		return null;
	}

	if (entry.armed) {
		entry.armed = false;
		writeAll(entries);
	}

	return entry;
}

/**
 * @description Points PDP breadcrumb of the listing category to the last visited state of the listing
 * (page, refinements, sorting) and makes the listing restore the position on breadcrumb click
 */
function initBreadcrumbs() {
	var entries = readAll();

	$('.breadcrumb [data-cgid]').each(function () {
		var $link = $(this),
			cgid = String($link.data('cgid')),
			entry = null;

		entries.forEach(function (item) {
			if (!entry && item.cgid === cgid) {
				entry = item;
			}
		});

		if (!entry) {
			return;
		}

		log('breadcrumb', cgid, '->', entry.url);
		$link.attr('href', entry.url).on('click', function () {
			var allEntries = readAll();
			allEntries.forEach(function (item) {
				item.armed = item.key === entry.key;
			});
			writeAll(allEntries);
		});
	});
}

module.exports = {
	log: log,
	getListingKey: getListingKey,
	save: save,
	getForRestore: getForRestore,
	initBreadcrumbs: initBreadcrumbs
};
